import { ReactElement, useMemo, useCallback } from 'react';

import { RouteReportCollectedItemsCompany } from '~services/route/report/types';
import TrackingInTransitDeliveriesList from '~components/TrackingInTransitDeliveriesList';
// eslint-disable-next-line max-len
import { TrackingInTransitDeliveriesItemBase } from '~components/TrackingInTransitDeliveriesList/types';
import { getDefaultAvatar } from '~utils/user';
import { DEFAULT_UUIID_EMPTY } from '~constants/commons';

import { useDashboardVariantV2CarrierContentCollectTrackingContext } from '../../../Context';

type CompaniesDeliveryExtraData = Pick<
  RouteReportCollectedItemsCompany,
  'companyId' | 'giverCompanyId'
>;

const DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabCompanies =
  (): ReactElement => {
    const {
      tabsData: {
        data: tabsData,
        selectedCompany: {
          value: selectedCompany,
          setValue: setSelectedCompany,
        },
      },
    } = useDashboardVariantV2CarrierContentCollectTrackingContext();

    const companiesDeliveryData = useMemo<
      TrackingInTransitDeliveriesItemBase<CompaniesDeliveryExtraData>[]
    >(() => {
      if (!tabsData?.collectedItemsByCompany) return [];

      return tabsData.collectedItemsByCompany.map((company) => ({
        label: company.name,
        totalCount: company.totalCollected,
        standarCount: company.totalCollectedNoFlex,
        flexCount: company.totalCollectedFlex,
        avatar: {
          src: getDefaultAvatar(company.logoUrl || undefined),
          alt: company.name,
        },
        extraData: {
          companyId: company.companyId,
          giverCompanyId: company.giverCompanyId,
        },
        isSelected:
          company.companyId === DEFAULT_UUIID_EMPTY
            ? selectedCompany?.giverCompanyId === company.giverCompanyId
            : selectedCompany?.companyId === company.companyId,
      }));
    }, [tabsData?.collectedItemsByCompany, selectedCompany]);

    const handleClickItem = useCallback(
      (extraData: CompaniesDeliveryExtraData) => {
        setSelectedCompany(extraData);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [],
    );

    return (
      <TrackingInTransitDeliveriesList
        data={companiesDeliveryData}
        onClickItem={handleClickItem}
      />
    );
  };

export default DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabCompanies;
